import BaseService from '@src/services/BaseService'

class AttachmentsService extends BaseService {
    constructor() {
        super('attachments')
    }
}

export default new AttachmentsService()
